import { Alert } from 'antd';

interface TrialBannerProps {
  daysRemaining: number;
  expiresAt: string;
}

export function TrialBanner({ daysRemaining }: TrialBannerProps) {
  if (daysRemaining > 14) return null;

  const type = daysRemaining <= 3 ? 'error' : daysRemaining <= 7 ? 'warning' : 'info';
  const message =
    daysRemaining <= 0
      ? 'Deneme süreniz dolmuştur. Hizmetlerinize devam etmek için ödeme yapınız.'
      : daysRemaining === 1
        ? 'Deneme süreniz yarın sona erecek!'
        : `Deneme sürenizin bitmesine ${daysRemaining} gün kaldı.`;

  return (
    <Alert
      type={type}
      message={message}
      banner
      showIcon
      closable={daysRemaining > 3}
      style={{ marginBottom: 0 }}
    />
  );
}
